(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["daisys-delivery-check"] && !Shopify.designMode) return;
  try {
    const daisysOpenDeliveryCheck = () => {
  const dialog = document.getElementById('DaisysDeliveryCheck');
  if (dialog && !dialog.open) dialog.showModal();
};
document.addEventListener('click', event => {
  const opener = event.target.closest('[data-daisys-delivery-open]');
  if (opener) {
    const dialog = document.getElementById('DaisysDeliveryCheck');
    if (dialog) { event.preventDefault(); daisysOpenDeliveryCheck(); }
  }
  const dialog = event.target.closest('#DaisysDeliveryCheck');
  if (!dialog) return;
  if (event.target.closest('[data-daisys-delivery-close]')) dialog.close();
  if (event.target.closest('[data-daisys-delivery-back]')) {
    dialog.querySelector('[data-daisys-delivery-address]').hidden = true;
    dialog.querySelector('[data-daisys-delivery-zip]').hidden = false;
    dialog.querySelector('#DaisysDeliveryZip').focus();
  }
  const choice = event.target.closest('[data-daisys-delivery-method]');
  if (choice) {
    const input = document.getElementById(`daisys-method-${choice.dataset.daisysDeliveryMethod}`);
    if (input) { dialog.close(); input.checked = true; input.dispatchEvent(new Event('change', {bubbles: true})); }
  }
});
document.addEventListener('submit', event => {
  if (!event.target.matches('[data-daisys-delivery-zip]')) return;
  event.preventDefault();
  const dialog = event.target.closest('dialog');
  const zip = event.target.querySelector('input').value.trim();
  dialog.querySelector('#DaisysDeliveryPostal').value = zip;
  event.target.hidden = true;
  dialog.querySelector('[data-daisys-delivery-address]').hidden = false;
  dialog.querySelector('#DaisysDeliveryName')?.focus();
});
const daisysInitializeDeliveryCheck = () => {
  const dialog = document.getElementById('DaisysDeliveryCheck');
  if (!dialog) return;
  if (dialog.querySelector('[data-daisys-delivery-success], [data-daisys-delivery-errors]')) {
    dialog.querySelector('[data-daisys-delivery-zip]').hidden = true;
    dialog.querySelector('[data-daisys-delivery-address]').hidden = false;
    daisysOpenDeliveryCheck();
  }
  try {
    if (sessionStorage.getItem('daisys_open_delivery_check') === '1') {
      sessionStorage.removeItem('daisys_open_delivery_check');
      daisysOpenDeliveryCheck();
    }
  } catch {}
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', daisysInitializeDeliveryCheck, {once: true});
else daisysInitializeDeliveryCheck();
document.addEventListener('shopify:section:load', daisysInitializeDeliveryCheck);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["daisys-fulfillment-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && document.documentElement.classList.contains('daisys-method-required')) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);
document.addEventListener('click', event => {
  const dialog = document.getElementById('DaisysShoppingMethod');
  if (!dialog) return;
  if (event.target.closest('[data-daisys-method-open]')) { if (!dialog.open) dialog.showModal(); }
  if ((event.target.closest('[data-daisys-method-close]') || event.target === dialog) && !document.documentElement.classList.contains('daisys-method-required')) dialog.close();
  const input = event.target.closest('[data-daisys-fulfillment] input[type="radio"]');
  if (input && input.value === input.form.dataset.current) input.form.requestSubmit();
});
document.addEventListener('change', event => {
  const form = event.target.closest('[data-daisys-fulfillment]');
  if (form && event.target.matches('input[type="radio"]')) form.requestSubmit();
});
document.addEventListener('submit', async event => {
  const form = event.target.closest('[data-daisys-fulfillment]');
  if (!form) return;
  event.preventDefault();
  const fieldset = form.querySelector('fieldset');
  if (fieldset.disabled) return;
  const status = form.querySelector('[role="status"]');
  const method = new FormData(form).get('attributes[daisys_fulfillment]');
  fieldset.setAttribute('aria-busy', 'true');
  fieldset.disabled = true;
  status.textContent = '';
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({attributes: {daisys_fulfillment: method, daisys_pricing_test: 'regios-20261021'}})
    });
    if (!response.ok) throw new Error('Cart update failed');
    try {
      sessionStorage.setItem('daisys_method_choice_v2', JSON.stringify({method, time: Date.now()}));
      if (method === 'local_delivery') sessionStorage.setItem('daisys_open_delivery_check', '1');
      else sessionStorage.removeItem('daisys_open_delivery_check');
    } catch {}
    window.location.reload();
  } catch {
    status.textContent = form.dataset.error;
    const previous = form.querySelector(`input[value="${form.dataset.current}"]`);
    if (previous) previous.checked = true;
    fieldset.disabled = false;
    fieldset.removeAttribute('aria-busy');
  }
});
const daisysInitializePricing = () => {
  const form = document.querySelector('[data-daisys-fulfillment]');
  const dialog = document.getElementById('DaisysShoppingMethod');
  if (!form || !dialog) return;
  const required = document.documentElement.classList.contains('daisys-method-required');
  dialog.addEventListener('close', () => {
    if (document.documentElement.classList.contains('daisys-method-required') && !dialog.open) dialog.showModal();
  });
  dialog.addEventListener('cancel', event => {
    if (document.documentElement.classList.contains('daisys-method-required')) event.preventDefault();
  });
  if (required) {
    document.querySelectorAll('dialog[open]').forEach(other => { if (other !== dialog) other.close(); });
    form.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; });
    if (!dialog.open) dialog.showModal();
  } else if (form.dataset.initialized !== 'true') {
    form.requestSubmit();
  }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', daisysInitializePricing, {once: true});
else daisysInitializePricing();
window.addEventListener('pageshow', event => { if (event.persisted) daisysInitializePricing(); });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["daisys-specials"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',function(event){if(!event.target.matches('#daisys-promo-campaign select[name="id"]'))return;var option=event.target.selectedOptions[0],card=event.target.closest('.daisys-offer');if(!option||!option.dataset.daisysPrices)return;var values=JSON.parse(option.dataset.daisysPrices),method=document.querySelector('[data-daisys-fulfillment]').dataset.current,regular=values[method],base=card.querySelector('.daisys-regular-price'),sale=card.querySelector('.daisys-sale-price');var discount=Number(card.dataset.daisysDiscount||0);var money=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:'USD'});base.textContent=money.format(regular/100);sale.textContent=money.format(Math.max(0,regular-discount)/100);});
  } catch(e) { console.error(e); }
})();

})();
